// api/core.js
import { useAppStore } from '@/stores/app'
import { Snackbar } from '@varlet/ui'

// ✅ APK 环境用完整域名，Web 环境用空字符串（走 Nginx 代理）
const API_BASE_URL = import.meta.env.VITE_APP_TARGET === 'apk'
  ? (import.meta.env.VITE_API_BASE_URL || '')
  : ''

export function getAuthHeaders() {
  const headers = { 'Content-Type': 'application/json' }
  const appStore = useAppStore()
  if (appStore.currentUser) {
    headers['Authorization'] = 'Bearer ' + encodeURIComponent(appStore.currentUser)
  }
  return headers
}

export async function apiRequest(url, options = {}) {
  const { method = 'GET', body, headers = {}, silent = false, ...rest } = options

  const requestHeaders = {
    ...getAuthHeaders(),
    ...headers
  }

  if (body) {
    requestHeaders['Content-Type'] = 'application/json'
  }

  const requestOptions = {
    method,
    headers: requestHeaders,
    ...rest
  }

  if (body) {
    requestOptions.body = JSON.stringify(body)
  }

  // ✅ APK 里拼上完整域名；Web 里 API_BASE_URL 为空，fullUrl === url，行为不变
  const fullUrl = url.startsWith('http') ? url : API_BASE_URL + url

  try {
    const response = await fetch(fullUrl, requestOptions)

    // 解析响应文本
    const text = await response.text()
    let data = null
    try {
      data = JSON.parse(text)
    } catch {
      // 非 JSON 响应
      if (!silent) {
        Snackbar.error('服务器响应异常')
      }
      throw new Error('Invalid JSON response')
    }

    // 401 未授权
    if (response.status === 401) {
      const appStore = useAppStore()
      appStore.logout()
      if (!silent) {
        Snackbar.error('登录已过期，请重新登录')
      }
      throw new Error('401')
    }

    // 403 无权限
    if (response.status === 403) {
      const msg = data.msg || data.message || '没有权限执行此操作'
      if (!silent) {
        Snackbar.error(msg)
      }
      throw new Error(msg)
    }

    // 404 未找到
    if (response.status === 404) {
      if (!silent) {
        Snackbar.error('请求的资源不存在')
      }
      return null
    }

    // 400 错误
    if (response.status === 400) {
      const msg = data.msg || data.message || '请求参数错误'
      if (!silent) {
        Snackbar.error(msg)
      }
      throw new Error(msg)
    }

    // 409 冲突
    if (response.status === 409) {
      const msg = data.msg || '数据冲突，请刷新后重试'
      if (!silent) {
        Snackbar.error(msg)
      }
      throw new Error(msg)
    }

    // 500 服务器错误
    if (response.status >= 500) {
      if (!silent) {
        Snackbar.error('服务器内部错误，请稍后重试')
      }
      throw new Error('服务器内部错误')
    }

    // 检查业务层面的错误（success: false）
    if (data && data.success === false) {
      const msg = data.msg || data.message || '操作失败'
      if (!silent) {
        Snackbar.error(msg)
      }
      return data
    }

    return data

  } catch (err) {
    // 网络错误
    if (!silent && err.message !== '401' && err.message !== 'Invalid JSON response') {
      Snackbar.error(err.message || '网络请求失败')
    }
    console.warn('请求失败:', url, err)
    throw err
  }
}